<template>
	<div><span class="biaoti">登录日志</span>
	<el-table :data="tableData" style="width: 100%">
		<el-table-column prop="date" label="登录时间" >
		</el-table-column>
		<el-table-column prop="rukou" label="登录入口" >
		</el-table-column>
		<el-table-column prop="zhongduan" label="终端设备" >
		</el-table-column>、
		<el-table-column prop="ip" label="IP" >
		</el-table-column>
		<el-table-column prop="openid" label="openid" >
		</el-table-column>
	</el-table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [{
					date: '2016-05-02',
					rukou: 'xiaochengxu',
					zhongduan: 'mobile',
					ip:'223.166.222.108	',
					openid:'ouSnT5HADVyqyFihSUvOtE7JHHYs'
				}]
			}
		}
	}
</script>

<style>
	.biaoti {
		display: block;
		width: 100%;
		text-indent: 10px;
		margin-bottom: 16px;
		font-size: 20px;
		color: #788188;
	}
</style>
